// mouseWheelScroll

import { TweenMax, Power1 } from 'gsap';
import Modernizr from 'modernizr';

const mouseWheelScroll = () => {
  const elements = $(window);
  const scrollTime = 0.7;
  const scrollDistance = 250;
  const enable = !!(!Modernizr.touchevents && Modernizr.csstransforms3d && window.TweenMax);
  if (enable) {
    const onScroll = (e) => {
      if (!$('body').hasClass('modal-open')) {
        e.preventDefault();
        const delta = e.originalEvent.wheelDelta / 120 || -e.originalEvent.detail / 3;
        const scrollTop = elements.scrollTop();
        const finalScroll = (scrollTop - parseInt(delta * scrollDistance, 10));
        TweenMax.to(elements, scrollTime, {
          scrollTo: { y: finalScroll, autoKill: true, force3D: Modernizr.csstransforms3d },
          ease: Power1.easeOut,
          overwrite: 5,
        });
      }
    };
    $(window).on('mousewheel DOMMouseScroll', onScroll);
  }
};

export default mouseWheelScroll;



// WEBPACK FOOTER //
// ./src/scripts/common/mouseWheelScroll.js